const skills = [
    {
        category: "Computer Vision",
        skills: [
            "Anomaly Detection",
            "PatchCore",
            "YOLOX",
            "SAM2/NanoSAM",
            "OpenCV",
            "Object Detection",
        ],
    },
    {
        category: "ML & Statistics",
        skills: [
            "PyTorch",
            "Transformers",
            "XGBoost",
            "scikit-learn",
            "Unsupervised Learning",
        ],
    },
    {
        category: "Edge & MLOps",
        skills: [
            "NVIDIA Triton",
            "Jetson AGX Orin",
            "TensorRT",
            "ONNX",
            "OpenVINO",
            "ClearML",
            "MLflow",
            "Docker",
            "GitHub Actions",
            "Pytest",
        ],
    },
    {
        category: "Data & Cloud",
        skills: [
            "PySpark",
            "Kafka",
            "Airflow",
            "Databricks",
            "GCP (Vertex AI, Cloud Run, Artifact Registry)",
            "Azure Kubernetes Service",
            "PostgreSQL",
            "Redis",
        ],
    },
    {
        category: "LLMs & Backend",
        skills: [
            "LangGraph",
            "LangChain",
            "RAG",
            "LLM Evaluation",
            "Hugging Face",
            "FastAPI",
        ],
    },
    {
        category: "Languages",
        skills: ["Python", "C/C++", "SQL", "TypeScript", "Java"],
    },
];

export default skills;
